module.exports = __webpack_public_path__ + "img/godot-blog.jpg_w545.a607a22f.jpg";